import {DetailParams, TableColumn, TableRow, TableValueAction, TableValueType} from '../../../shared/models';
import {formatValue} from '../../../shared/helpers';
import {Padron} from './padrones-core.model';
import {Empresa, EmpresasDetailParams} from '../empresas';
import {IngenieroAgronomoCore} from '../ingenieros-agronomos';
import { Rol } from 'src/app/core';

export interface PadronesCoreTableColumn extends TableColumn {
  literalFormat?: (v: any) => string;
  actionFormat?: (padron: Padron, sources?: PadronesCoreTableSources) => TableValueAction;
}

export interface PadronesCoreTableParams {
  columns?: PadronesCoreTableColumn[];
  padrones: Padron[];
  sources: PadronesCoreTableSources;
  filter?: boolean;
  pagination?: boolean;
}

export interface PadronesCoreListParams {
  padron: DetailParams;
  propietario?: EmpresasDetailParams;
}

export enum PadronesCoreTableAction {
  REPORTE = 'Reporte',
  CAMBIAR_PROPIETARIO = 'CambiarPropietario',
  ADD_PROPIETARIO = 'AddPropietario',
  SELECCIONAR = 'SelectPadron'
}

export interface PadronesCoreTableActionValue {
  action: PadronesCoreTableAction;
  padron: Padron;
}

export interface PadronesCoreTableRowSource {
  padron: Padron;
}

export interface PadronesCoreTableSources {
  rolId: string;
  personaId: string;
  empresas: Empresa[];
  ingenierosAgronomos: IngenieroAgronomoCore[];
}

export function resolvePadronesCoreTableCellValue(
  padron: Padron,
  column: PadronesCoreTableColumn,
  sources: PadronesCoreTableSources
): string | string[] {
  let value = '';
  switch (column.name) {
    case 'padronPropietarioId':
      const emp = sources.empresas.find(e => padron[column.name] === e.empresaId);
      if (emp){
        value = formatValue(emp.empresaRazonSocial, column.literalFormat);
      }
      break;

    default: value = formatValue(padron[column.name], column.literalFormat);
  }
  return value;
}

export function createPadronesCoreTableRow(
  padron: Padron,
  columns: PadronesCoreTableColumn[],
  sources: PadronesCoreTableSources
): TableRow {
  const row: TableRow = {
    __source__: padron
  };
  for (const column of columns) {
    switch (column.type) {
      case TableValueType.CHECK:
        row[column.name] = {value: column.name, text: column.name};
        break;
      case TableValueType.ACTION:
        row[column.name] = column.actionFormat
          ? column.actionFormat(padron, sources)
          : { value: column.name, text: column.name, icon: 'bomb' };
        break;
      case TableValueType.LITERAL:
        row[column.name] = resolvePadronesCoreTableCellValue(padron, column, sources);
        break;
    }
  }
  return row;
}



export const PADRONESCORETABLE_COLUMNS_ACTIONS_DEFAULT: PadronesCoreTableColumn[] = [
  {
    type: TableValueType.ACTION,
    name: PadronesCoreTableAction.REPORTE,
    label: '',
    sort: false,
    filter: false,
    actionFormat: _ => ({
      value: PadronesCoreTableAction.REPORTE,
      text: 'Reporte',
      icon: 'file'
    })
  },
  {
    type: TableValueType.ACTION,
    name: PadronesCoreTableAction.CAMBIAR_PROPIETARIO,
    label: '',
    sort: false,
    filter: false,
    actionFormat: (p: Padron, sources: PadronesCoreTableSources) => {
      let result = null;
      const emp = sources.empresas.find(e => p.padronPropietarioId === e.empresaId);
      if (emp){
        if (sources.rolId === Rol.ASEGURADORA || sources.rolId === Rol.USUARIO_LIBRE){
          result = {
            value: PadronesCoreTableAction.CAMBIAR_PROPIETARIO,
            text: 'Desasociar Propietario del Padrón',
            icon: 'exchange-alt'
          };
        }
      }
      else{
        if (sources.rolId === Rol.USUARIO_LIBRE){
          result = {
            value: PadronesCoreTableAction.ADD_PROPIETARIO,
            text: 'Agregar Propietario',
            icon: 'plus-circle'
          };
        }
      }
      return result;
    }
  },
];

export const PADRONESCORETABLE_COLUMNS_DEFAULT: PadronesCoreTableColumn[] = [
  {
    type: TableValueType.LITERAL,
    name: 'padronId',
    label: 'Nro',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'departamentoNombre',
    label: 'Departamento',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'padronArea',
    label: 'Área (ha)',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'padronPropietarioId',
    label: 'Propietario',
    sort: true,
    filter: true
  },
];
